<template>
    <div class="memberList">
        <div class="show_container">
             <div class="staff_manage_head flex  align-cen">
                <div class="add_btn" @click="openTeam">
                    <div class="add_btn_icon"></div>
                    <span>添加成员</span>
                </div>
             </div>
              <div class="staff_manage_center">
                 <div class="businessList-container-table">
                            <el-table
                ref="multipleTable"
                :data="itemList"
                tooltip-effect="dark"
                style="width: 100%"
                id='mytable'
                :header-cell-style="{background:'#eeeeee',color:'#666',paddingBottom:'10px'}"
                >
                     <el-table-column prop="loginName" label="手机/账号" align="center">
                 </el-table-column>
                  <el-table-column prop="userName" label="昵称/姓名" align="center">
                 </el-table-column>
                 <el-table-column label="角色" align="center">
                    <template slot-scope="scope">
                        <p>
                            <span v-for="(item,index) in scope.row.roleList">
                                {{item.roleName}} <span v-if="index == 0 && scope.row.roleList.length>1">/</span>
                            </span>
                        </p>
                    </template>
                 </el-table-column>
                  <el-table-column label="关联仿真系统" align="center">
                     <template slot-scope="scope">
                      <p style="color:red;cursor:pointer" @click="openAppList(scope.row)">{{scope.row.allocateNum}}个</p>
                  </template>
                 </el-table-column>
                  <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="150"          
                    >
                     <template slot-scope="scope">
                      <el-button type="text" style="color:red" @click="openEditmember(scope.row)">编辑</el-button> 
                      <el-button type="text" style="color:red" @click="deletS(scope.row)">删除</el-button> 
                     </template>
                   </el-table-column>
             </el-table>
              <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                 </div>
              </div>
        </div>
             <!-- 已分配系统弹窗 -->
           <el-dialog
  title="已分配系统"
  :visible.sync="centerDialogVisible"
  width="50%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
  >
     <div class="businessList-container-table">
    <el-table
          ref="multipleTable1"
          :data="systesList"
          tooltip-effect="dark"
          style="width: 100%"
          id='mytable'
          :header-cell-style="{background:'#fff',color:'#90909e',paddingBottom:'20px'}"
        >
         <el-table-column prop="appName" label="系统名称" align="center" width="300">
          </el-table-column>
           <el-table-column  label="登录次数" align="center">
            <template slot-scope="scope">
                <p>{{scope.row.loginNum || '-'}}</p>
            </template>
          </el-table-column>
            <el-table-column  label="最后学习时间" align="center">
            <template slot-scope="scope">
                <p >{{scope.row.lastStudyTime || '-'}}</p>
            </template>
          </el-table-column>
          <el-table-column  label="考试次数" align="center">
            <template slot-scope="scope">
                <p >{{scope.row.examNum || '-'}}</p>
            </template>
          </el-table-column>
          <el-table-column  label="考试合格次数" align="center">
            <template slot-scope="scope">
                <p >{{scope.row.passNum || '-'}}</p>
            </template>
          </el-table-column>
    </el-table>
   </div>
           </el-dialog>
    </div>
</template>
<script>
import { getTeacherAccount,getTeacherAppList} from "@/api/enterprise/index"; // 成员列表、关联仿真系统列表
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'memberList',
    components:{
      paginaTion
    },
    data() {
        return {
            centerDialogVisible:false,
            bussID:'',
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            itemList:[],
            systesList:[]
        }
    },
    created () {
          const businessInfo = this.$locaStorage.setAge().get('businessInfo')
         this.bussID = businessInfo.id
         this.getthisInfo()
    },
    methods: {
         // 删除跳转企业管理后台deletS
        deletS(data){
             const newurl = this.$router.resolve({name: 'teamAdmin', query: {}})
             window.open(newurl.href,'_blank')
        },
        // 打开成员编辑
        openEditmember(data){
            this.$router.push({
                name:'editMember',
                query:{
                    businessId:data.businessId,
                    id:data.id
                }
            })
        },
        // 打开关联仿真系统
        openAppList(data){
        this.centerDialogVisible = true
        this.getSystem(data)
        },
        getSystem(data){
             getTeacherAppList({id:data.businessId,accountId:data.id},'enterprise')
            .then(res =>{
               this.systesList = res.data
            })
        },

               // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getthisInfo()
      },
        // 打开添加成员
        openTeam(){
             const newurl = this.$router.resolve({name: 'teamAdmin', query: {}})
             window.open(newurl.href,'_blank')
        },
        // 成员列表
        getthisInfo(){
            let params = {
                id:this.bussID,
                size:this.PageSize,
                current:this.currentPage,
            }
             getTeacherAccount(params,'enterprise')
          .then(res => {
            this.itemList = res.data.records
            this.totalCount = res.data.total
          })
          .catch(err => {

          })
        },
    },
}
</script>
<style lang="scss" scoped>
.memberList{
    padding-top: 20px;
    .show_container {
        max-width: 1400px;
        min-width: 1145px;
        background: #fff;
        background: #fff;
        box-shadow: 0 0 7px 0 rgba(197,197,197,0.14);
        border-radius: 2px;
        margin: 0 auto;
        .staff_manage_head{
    height: 60px;
    line-height: 60px;
    border-radius: 2px;
    padding: 0 40px;
    box-shadow: 0 0 7px 0 rgba(197,197,197,0.34);
     .add_btn{
    width: 129px;
    height: 38px;
    line-height: 38px;
    border-radius: 5px;
    cursor: pointer;
   background-image: linear-gradient(60deg, #36c0fd 0%, #3672fd 100%)!important;
    color: #fff;
    font-size: 14px;
    text-align: center;
    .add_btn_icon{
     margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    line-height: 20px;
    background: url('../../../assets/images/setting_add_icon.svg') no-repeat 0 0;
    }
    }
    }
    .staff_manage_center{
      margin-bottom: 20px;
      margin-top: 10px;
    }
    }
}
::v-deep{
      .jiange{
      padding-bottom: 20px;
      padding-right: 20px;
    }
    .el-table__body{

        td{
           padding: 5px 0;
        }
    }
    }
</style>